import { mul } from '@zenlayer/zen-design/esm/_util/calc';
export const calc30daysPrice = (unitPrice, unit) => {
    if (unitPrice === undefined || !unit) {
        return undefined;
    }
    const _unit = unit.toLowerCase();
    if (['month', 'day', 'hour'].includes(_unit) === false) {
        return undefined;
    }
    let price = 0;
    if (_unit === 'month') {
        price = unitPrice;
    }
    else if (_unit === 'day') {
        price = mul(unitPrice, 30);
    }
    else if (_unit === 'hour') {
        price = mul(unitPrice, 30, 24);
    }
    return { price, unit: 'month' };
};
